import * as React from 'react';
import styled, { withTheme, keyframes } from 'styled-components';
import { rem } from 'polished';
import { __, __r } from 'react-i18n';
import { SvgIcon, IconType } from '../../General/SvgIcon';
import {
  FlexCol,
  FlexRowCenter,
  FlexColCenter,
} from '../../../Defaults/Flexbox/Flexbox';
import { OutsideClick } from '../../../Defaults/OutsideClick';
import { SanitasButtonPrimary, SanitasButtonTertiary } from '../../../..';

interface Props {
  handleClose: any;
  isActive: boolean;
  redirectToUrl: () => void;
}

export const Modal = ({ handleClose, isActive, redirectToUrl }: Props) => {
  const handleKeyDown = (event): void => {
    // 27 is a code for Escape button
    if (event.which === 27) {
      handleClose();
    }
    // 13 is a code for Enter button
    if (event.which === 13) {
      redirectToUrl();
    }
  };

  const onKeyDown = () => {
    React.useEffect(() => {
      document.addEventListener('keydown', handleKeyDown);
      return () => {
        document.removeEventListener('keydown', handleKeyDown);
      };
    });
  };

  if (!isActive) {
    return null;
  }

  return (
    <div>
      <ModalStyle />
      <ModalHolder>
        <OutsideClickWrapper>
          <OutsideClick handleFunction={handleClose}>
            <Wrapper handleClick={onKeyDown()}>
              <TitleWrapper>
                <Title>
                  <Checked>
                    <SvgIcon
                      viewBox="-2, -2, 19, 19"
                      icon={IconType.checked}
                      alt="Produkt pridaný"
                      title="Produkt pridaný"
                    />
                  </Checked>
                  {__('Produkt bol pridaný do košíka')}
                </Title>
              </TitleWrapper>
              <CloseModal>
                <SvgIcon
                  width={24}
                  height={24}
                  icon={IconType.close}
                  alt="Zavrieť okno"
                  title="Zavrieť okno"
                  cursor={'pointer'}
                  fill={'black'}
                  onClick={handleClose}
                />
              </CloseModal>
              <ButtonsCover>
                <SanitasButtonPrimary onClick={redirectToUrl}>
                  {__('Dokončiť objednávku')}
                </SanitasButtonPrimary>
                <SanitasButtonTertiary onClick={handleClose}>
                  {__('Pokračovať v nakupovaní')}
                </SanitasButtonTertiary>
              </ButtonsCover>
            </Wrapper>
          </OutsideClick>
        </OutsideClickWrapper>
      </ModalHolder>
    </div>
  );
};

const animateIn = keyframes`
   0% {
    opacity: 0;
    transform: scale(0.6) translateY(-8px);
  }
  
  100% {
    opacity: 1;
  }
`;

const ModalStyle = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: ${({ theme }) => theme.colors.black};
  opacity: 0.2;
  z-index: ${({ theme }) => theme.index.modal};
`;

const ModalHolder = styled(FlexColCenter)`
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: ${({ theme }) => theme.index.modal};
`;

const OutsideClickWrapper = styled.div`
  width: 100%;
  max-width: ${rem(564)};
`;

const Wrapper = styled(FlexCol)`
  padding: ${rem(32)};
  width: 100%;
  position: relative;
  opacity: 1;
  background: white;
  border-radius: ${rem(4)};
  margin: ${rem(16)} auto;
  box-shadow: ${({ theme }) => theme.boxShadow.default};
  display: block;
  animation: ${animateIn} 0.15s ease;

  ${({ theme }) => theme.mediab.m580`
      padding: ${rem(24)};
      margin: ${rem(16)};
      width: initial;
  `};
`;

const TitleWrapper = styled(FlexRowCenter)`
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: ${rem(16)};
  padding-right: ${rem(24)};
`;

const Title = styled.h3`
  font-family: objektiv-mk1, sans-serif;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.black};
  font-size: ${rem(24)};
  line-height: 1.1666666667;
  margin: 0;
  display: inline-flex;
  align-items: center;

  ${({ theme }) => theme.media(0, 'sm')} {
    font-size: ${rem(24)};
    line-height: ${rem(31)};
  }
`;

const Checked = styled.div`
  flex: 1 0 48px;

  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: ${rem(48)};
  height: ${rem(48)};
  border-radius: 50%;
  border: 3px solid ${({ theme }) => theme.colors.primary};
  margin-right: ${rem(16)};

  ${({ theme }) => theme.media(0, 'sm')} {
    display: none;
  }
`;

const ButtonsCover = styled.div`
  display: block;

  button {
    display: inline-flex;
    margin-top: ${rem(16)};

    &:first-child {
      margin-right: ${rem(16)};
    }

    &:last-child {
      margin-right: 0;
    }
  }
`;

const CloseModal = styled.div`
  display: inline-block;
  position: absolute;
  right: ${rem(24)};
  top: ${rem(24)};
`;
